export default function getIsAppInstalled(appFromAppsApiCall) {
  return (
    appFromAppsApiCall.isInstallionStarted &&
    Boolean(appFromAppsApiCall.installedAt)
  );
}
